import { Component, OnInit, AfterViewInit, OnDestroy, Inject, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { LoginService } from 'src/app/managers/login.service';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { LoginComponent } from 'src/app/components/login/login.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('userNameField', { static: true }) userNameElement: ElementRef;
  email: string;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, functionsService: FunctionsService,
              private _snackBar: MatSnackBar, private _dialogRef: MatDialogRef<LoginComponent>, @Inject(MAT_DIALOG_DATA) private _data: any) { 
    super(route, loginManager, clientConfig, dialog);
  }

  ngOnInit() {
    super.ngOnInit();
    this.parentComponent = this._data.parentComponent;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.userNameElement.nativeElement.focus();
    }, 0);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  readyToSend(): boolean {
    return (this.email !== undefined && this.email.length > 0) ? true : false;
  }

  async sendPassword() {
    this._snackBar.open('Sending...');
    let resposneMsg = await this.loginManager.sendEmailPasswordAsync(this.email);
    this._snackBar.dismiss();

    if (resposneMsg.Status === CoreResponseStatus.OK) {
      this.openAlertDialog('Send Password', 'Your password has been successfully sent to the email ' + this.email, '400px', '200px');
      this._dialogRef.close(this.email);
    }
    else {
      this.openAlertDialog('Send Password', 'Failed to send your password: ' + resposneMsg.Message, '400px', '200px');
      this._dialogRef.close('');
    }
  }

  cancel() {
    this._dialogRef.close('');
  }
}
